import {
  Button,
  CircularProgress,
  Divider,
  Flex,
  Icon,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  SimpleGrid,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import IconBox from "components/icons/IconBox";
import {
  buscarBoletoBase64,
  gerarBoletoBase64,
  cancelarPedidoApi,
  recuperarLinhaDigitavel,
} from "config/apis/requests";
import {
  convertDateToFormattedString,
  downloadPDF,
  formatCurrencyFloor,
  maskDataHistoricoSemHora,
  maskDataHistorico,
} from "config/functions";
import { useEffect, useState } from "react";

import {
  MdAlarm,
  MdCancel,
  MdCardMembership,
  MdCheckCircle,
  MdOutlineContentCopy,
  MdPictureAsPdf,
  MdSearch,
  MdBuild,
  MdCallMerge,
} from "react-icons/md";
import { Pedido } from "views/admin/atendimento/profile/components/ClientePedido";
import PopOverAlertOrange from "components/popAlert/popAlert";
import PopOverAlert from "components/popAlert/popAlert";

export default function Transaction(props: {
  handleRefresh?: any;
  vlTaxa: string;
  dtPagamento: string;
  tpPagamento: string;
  idContaAcesso: string;
  idProduto: any;
  date: string;
  pedido: string;
  status: string;
  descricao: string;
  valor: string;
  [x: string]: any;

  extrato: any;
}) {
  const {
    handleRefresh,
    vlTaxa,
    dtPagamento,
    tpPagamento,
    idContaAcesso,
    idProduto,
    date,
    pedido,
    icon,
    status,
    descricao,
    valor,
    extrato,
    ...rest
  } = props;
  const brandColor = useColorModeValue("brand.500", "white");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const iconBoxBg = useColorModeValue("secondaryGray.300", "navy.700");
  const textGrayDataBg = useColorModeValue("secondaryGray.500", "navy.700");
  const textGrayBg = useColorModeValue("secondaryGray.900", "navy.700");
  const textYelBg = useColorModeValue("yellow.500", "navy.300");
  const textVerdeBg = useColorModeValue("green.500", "navy.300");
  const textOrangeBg = useColorModeValue("orange.500", "navy.300");
  const textRedBg = useColorModeValue("red.500", "navy.300");
  const textBlueBg = useColorModeValue("blue.500", "navy.300");
  const textDarkBlueBg = useColorModeValue("blue.300", "navy.700");
  const [modal, setModal] = useState(false);
  const [pedidoModal, setPedidoModal] = useState("");
  const [modalView, setModalView] = useState(false);
  const [modalViewLinha, setModalViewLinha] = useState(false);
  const [pedidoModalView, setPedidoModalView] = useState("");
  const [pedidoModalViewLinha, setPedidoModalViewLinha] = useState("");
  const [linhaRecuperavel, setLinhaRecuperavel] = useState("");
  const [contaAcesso, setContaAcesso] = useState<string>(idContaAcesso);
  const bodyPedido = new Pedido();
  const [isOpenErro, setIsOpenErro] = useState(false);
  const [tipoErroPedido, setTipoErroPedido] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOpenGreen, setIsOpenGreen] = useState(false);
  const [loadingRecuperarLinha, setLoadingRecuperarLinha] = useState(false);
  const [loadingBuscarBoleto, setLoadingBuscarBoleto] = useState(false);
  const [motivoSelect, setMotivoSelect] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [motivos, setMotivos] = useState([]);
  const handleOpenAlertErro = () => {
    setIsOpenErro(!isOpenErro);
  };

  const handleOpenAlert = (status: boolean) => {
    setIsOpen(status);
  };

  const [statusPopOver, setStatusPopOver] = useState("warning");
  const [titlePopOver, setTitlePopOver] = useState("Ops...");
  const [subtitlePopOver, setSubtitlePopOver] = useState("");

  const showPopOver = (status: string, title: string, subtitle: string) => {
    handleOpenAlert(true);
    setStatusPopOver(status);
    setTitlePopOver(title);
    setSubtitlePopOver(subtitle);
  };

  enum Tipo {
    AGUARDANDO_PAGAMENTO = "AGUARDANDO_PAGAMENTO",
    AGUARDANDO_GERACAO_BOLETO = "AGUARDANDO_GERACAO_BOLETO",
    PAGO = "PAGO",
    CANCELADO = "CANCELADO",
    PRODUZIDO = "PRODUZIDO",
    EM_PRODUCAO = "EM_PRODUCAO",
    PAGO_COM_DIFERENCA = "PAGO_COM_DIFERENCA",
    CANCELADO_PAGAMENTO_VENCIDO = "CANCELADO_PAGAMENTO_VENCIDO",
  }

  enum TipoPagamento {
    CONTA_VIRTUAL = "CONTA_VIRTUAL",
    CARTAO_DE_CREDITO = "CARTAO_DE_CREDITO",
    CARTAO_DE_DEBITO = "CARTAO_DE_DEBITO",
    PIX = "PIX",
    BOLETO = "BOLETO",
    GRATUITO = "GRATUITO",
    DEPOSITO = "DEPOSITO",
    TRANSFERENCIA = "TRANSFERENCIA",
    CANCELADO_PAGAMENTO_VENCIDO = "CANCELADO PAGAMENTO VENCIDO",
  }
  const statusCor = (status: any) => {
    switch (status) {
      case Tipo.AGUARDANDO_GERACAO_BOLETO:
        return (
          <Text color={textYelBg} fontSize="md" fontWeight="700">
            Aguardando pagamento
          </Text>
        );
      case Tipo.AGUARDANDO_PAGAMENTO:
        return (
          <Text color={textYelBg} fontSize="md" fontWeight="700">
            Aguardando pagamento
          </Text>
        );
      case Tipo.PAGO:
        return (
          <Text color={textVerdeBg} fontSize="md" fontWeight="700">
            Pago
          </Text>
        );
      case Tipo.CANCELADO:
        return (
          <Text color={textRedBg} fontSize="md" fontWeight="700">
            Cancelado
          </Text>
        );
      case Tipo.PRODUZIDO:
        return (
          <Text color={textBlueBg} fontSize="md" fontWeight="700">
            Cartão produzido
          </Text>
        );
      case Tipo.EM_PRODUCAO:
        return (
          <Text color={textDarkBlueBg} fontSize="md" fontWeight="700">
            Cartão em produção
          </Text>
        );
      case Tipo.PAGO_COM_DIFERENCA:
        return (
          <Text color={textOrangeBg} fontSize="md" fontWeight="700">
            Pago com diferença
          </Text>
        );
      case Tipo.CANCELADO_PAGAMENTO_VENCIDO:
        return (
          <Text color={textRedBg} fontSize="md" fontWeight="700">
            Cancelado por pagamento vencido
          </Text>
        );

      default:
        return (
          <Text color={textBlueBg} fontSize="md" fontWeight="700">
            {status}
          </Text>
        );
    }
  };

  const tipoPagamento = (tpPagto: any) => {
    switch (tpPagto) {
      case TipoPagamento.PIX:
        return "Pix";
      case TipoPagamento.BOLETO:
        return "Boleto";
      case TipoPagamento.CONTA_VIRTUAL:
        return "Conta virtual";
      case TipoPagamento.CARTAO_DE_CREDITO:
        return "Cartão de crédito";
      case TipoPagamento.CARTAO_DE_DEBITO:
        return "Cartão de débito";
      case TipoPagamento.GRATUITO:
        return "Gratuito";
      case TipoPagamento.DEPOSITO:
        return "Depósito";
      case TipoPagamento.TRANSFERENCIA:
        return "Transferência";
    }
  };

  const handleChangeSelectCancelamentoMotivo = (event: {
    target: { value: any };
  }) => {
    setMotivoSelect(event.target.value);
  };

  useEffect(() => {
    if (localStorage.getItem("motivosCancelamento") !== null) {
      const storedMotivosStr = localStorage.getItem("motivosCancelamento");
      if (!storedMotivosStr) {
        setMotivos([]);
        showPopOver("error", "Ops...", "Erro ao buscar motivos cancelamento!");
      } else {
        try {
          const storedMotivos: any[] = JSON.parse(storedMotivosStr);

          const filtrados = storedMotivos.filter((item: any) => item.id !== 8);
          setMotivos(filtrados);
        } catch (e) {
          setMotivos([]);
          showPopOver(
            "error",
            "Ops...",
            "Erro ao processar motivos cancelamento!"
          );
        }
      }
    }
  }, []);

  const statusIcon = (status: any) => {
    switch (status) {
      case Tipo.AGUARDANDO_PAGAMENTO:
        return <Icon as={MdAlarm} color={textYelBg} w="20px" h="18px" />;
      case Tipo.AGUARDANDO_GERACAO_BOLETO:
        return <Icon as={MdAlarm} color={textYelBg} w="20px" h="18px" />;
      case Tipo.PAGO:
        return (
          <Icon as={MdCheckCircle} color={textVerdeBg} w="20px" h="18px" />
        );
      case Tipo.EM_PRODUCAO:
        return <Icon as={MdBuild} color={textDarkBlueBg} w="20px" h="18px" />;
      case Tipo.CANCELADO:
        return <Icon as={MdCancel} color={textRedBg} w="20px" h="18px" />;
      case Tipo.PRODUZIDO:
        return (
          <Icon as={MdCardMembership} color={textBlueBg} w="20px" h="18px" />
        );
      case Tipo.PAGO_COM_DIFERENCA:
        return <Icon as={MdCallMerge} color={textOrangeBg} w="20px" h="18px" />;
      case Tipo.CANCELADO_PAGAMENTO_VENCIDO:
        return <Icon as={MdCancel} color={textRedBg} w="20px" h="18px" />;
    }
  };
  const onChangeModal = (pedido: any) => {
    if (pedido === 0) {
      setPedidoModal("");
      setLoading(false);
    } else {
      setPedidoModal(pedido);
    }

    setModal(!modal);
  };

  const valorTotal = (valorPedido: any, valTaxa: any) => {
    return valorPedido + valTaxa / 100;
  };

  const onChangeModalView = (pedido: any) => {
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "none";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "none";
    if (pedido === 0) {
      setPedidoModalView("");
      if (document.getElementById("fotoElementoUsuario"))
        if (document.getElementById("fotoElementoUsuario"))
          document.getElementById("fotoElementoUsuario").style.display =
            "block";
      if (document.getElementById("fotoElementoUsuario2"))
        if (document.getElementById("fotoElementoUsuario2"))
          document.getElementById("fotoElementoUsuario2").style.display =
            "block";
    } else {
      setPedidoModalView(pedido);
    }

    setModalView(!modalView);
  };

  const onChangeModalViewLinha = (pedido: any) => {
    if (pedido === 0) {
      setPedidoModalViewLinha("");
    } else {
      setPedidoModalViewLinha(pedido);
    }

    setModalViewLinha(!modalViewLinha);
  };

  const statusCancelamento = (id: any) => {
    const motivo = motivos.find((item: any) => item.id == id);
    return (
      <Text color={"red.500"} fontSize="md" fontWeight="800">
        {motivo ? motivo.descricao : ""}
      </Text>
    );
  };

  const recuperarLinha = (pedido: any) => {
    setLoadingRecuperarLinha(true);
    recuperarLinhaDigitavel(pedido).then(function (result) {
      if (result !== 500 || result < 400) {
        setLinhaRecuperavel(result.linhaDigitavel);
        onChangeModalViewLinha(pedido);
        setLoadingRecuperarLinha(false);
      } else {
        handleOpenAlertErro();
        setTipoErroPedido("Erro ao buscar linha digitável!");
        setLoadingRecuperarLinha(false);
      }
    });
  };
  const buscarBoleto = (pedido: any) => {
    setLoadingBuscarBoleto(true);

    gerarBoletoBase64(pedido).then(function (result: any) {
      setTimeout(async () => {
        buscarBoletoBase64(pedido).then(function (result: any) {
          if (result.boletoBase64) {
            const nomeDocPdf = "Boleto_Pagamento_" + pedido + ".pdf";
            downloadPDF(
              `data:application/pdf;base64,${result.boletoBase64}`,
              nomeDocPdf
            );
            setLoadingBuscarBoleto(false);
          } else {
            setTipoErroPedido(
              "Erro ao buscar boleto! Verifique se o documento é um CPF!"
            );
            setIsOpenErro(!isOpenErro);
            setLoadingBuscarBoleto(false);
          }
        });
      }, 6000);
    });
  };

  const cancelarPedido = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    bodyPedido.idContaAcessoCancelamento = user.jti;
    bodyPedido.numeroPedido = pedido;
    bodyPedido.idMotivoCancelamentoPedido = motivoSelect;

    if (bodyPedido.idMotivoCancelamentoPedido != 0) {
      setLoading(!loading);
      cancelarPedidoApi(bodyPedido).then(function (result) {
        if (result < 400) {
          showPopOver("success", "Pedido", "Pedido excluído com sucesso!");
          setLoading(!loading);
          setTimeout(() => {
            handleRefresh(true);
          }, 2000);
        } else {
          setTipoErroPedido("Erro ao excluir pedido!");
          setIsOpenErro(!isOpenErro);
          setLoading(!loading);
        }
      });
    }

    onChangeModal(0);
  };

  return (
    <>
      <PopOverAlert
        handleOpenAlert={handleOpenAlert}
        isOpen={isOpen}
        status={statusPopOver}
        title={titlePopOver}
        subtitle={subtitlePopOver}
      />
      <Flex
        justifyContent="center"
        mt="10px"
        mb="10px"
        alignItems="center"
        w="100%"
        {...rest}
      >
        <IconBox
          h="42px"
          w="42px"
          bg={iconBoxBg}
          me="20px"
          icon={statusIcon(extrato.status)}
        />

        <Flex direction="column" align="start" me="auto">
          <Text color={textGrayDataBg} fontSize="sm" me="6px" fontWeight="700">
            {convertDateToFormattedString(extrato.data)}
          </Text>
          <Text color={textGrayBg} fontSize="small" fontWeight="500">
            {window.config.tenant === "macae"
              ? "Crédito em Conta Educa + Macaé Benefício"
              : extrato.tipo}
          </Text>
          <Text fontSize="medium" fontWeight="700">
            {statusCor(extrato.status)}
          </Text>
          {extrato.valor &&
          idProduto !== 2 &&
          extrato.status !== "CANCELADO_PAGAMENTO_VENCIDO" &&
          idProduto !== 6 &&
          (extrato.idTipo === 3 || extrato.idTipo === 11) &&
          extrato.tipoPagamento !== "GRATUITO" ? (
            <Text color={textGrayBg} fontSize="sm" fontWeight="500">
              Valor pago:
              <b> {formatCurrencyFloor(extrato?.valorPago)}</b>
            </Text>
          ) : null}
          {extrato?.valorTaxaEntrega ? (
            <Text color={textGrayBg} fontSize="sm" fontWeight="500">
              Taxa de envio:
              <b> {formatCurrencyFloor(extrato?.valorTaxaEntrega)}</b>
            </Text>
          ) : null}
        </Flex>
        <Flex direction="column" align="center" justify="space-between">
          <Text
            ms="auto"
            color={textColor}
            fontSize="sm"
            fontWeight="300"
            mr="10px"
          >
            Pedido: <b>{pedido} </b>
          </Text>
          <Text ms="auto" color={textColor} fontSize="small" fontWeight="700">
            <Flex
              direction="row"
              alignItems="baseline"
              justify="flex-end"
              w={"160px"}
            >
              {extrato?.status === "AGUARDANDO_PAGAMENTO" ? (
                <>
                  <IconButton
                    mt="12px"
                    aria-label="Transfer"
                    borderRadius="50%"
                    w="0px"
                    h="0px"
                    mb="0px"
                    icon={
                      <Icon
                        as={MdSearch}
                        width="28px"
                        height="28px"
                        color={textGrayBg}
                        onClick={() => onChangeModalView(pedido)}
                      />
                    }
                  />

                  <>
                    {loadingBuscarBoleto ? (
                      <CircularProgress
                        isIndeterminate
                        color="green.300"
                        size="25px"
                      />
                    ) : tpPagamento === "BOLETO" ? (
                      <IconButton
                        mt="12px"
                        aria-label="Transfer"
                        borderRadius="50%"
                        w="0px"
                        h="0px"
                        mb="0px"
                        icon={
                          <Icon
                            as={MdPictureAsPdf}
                            width="28px"
                            height="28px"
                            color={textBlueBg}
                            onClick={() => buscarBoleto(pedido)}
                          />
                        }
                      />
                    ) : null}

                    {loadingRecuperarLinha ? (
                      <CircularProgress
                        isIndeterminate
                        color="green.300"
                        size="25px"
                      />
                    ) : tpPagamento !== "PIX" ? (
                      <IconButton
                        mt="12px"
                        aria-label="Transfer"
                        borderRadius="50%"
                        w="0px"
                        h="0px"
                        mb="0px"
                        icon={
                          <Icon
                            as={MdOutlineContentCopy}
                            width="28px"
                            height="28px"
                            color={textYelBg}
                            onClick={() => recuperarLinha(pedido)}
                          />
                        }
                      />
                    ) : null}
                  </>

                  {extrato?.status === "AGUARDANDO_PAGAMENTO" ? (
                    <IconButton
                      mt="12px"
                      aria-label="Transfer"
                      borderRadius="50%"
                      w="0px"
                      h="0px"
                      mb="0px"
                      icon={
                        <Icon
                          as={MdCancel}
                          width="28px"
                          height="28px"
                          color={textRedBg}
                          onClick={() => onChangeModal(pedido)}
                        />
                      }
                    />
                  ) : null}
                </>
              ) : (
                <>
                  <IconButton
                    mt="12px"
                    aria-label="Transfer"
                    borderRadius="50%"
                    w="0px"
                    h="0px"
                    mb="0px"
                    icon={
                      <Icon
                        as={MdSearch}
                        width="28px"
                        height="28px"
                        color={textGrayBg}
                        onClick={() => onChangeModalView(pedido)}
                      />
                    }
                  />
                </>
              )}
            </Flex>
          </Text>
          <Text
            ms="auto"
            color={textColor}
            fontSize="lg"
            me="8px"
            fontWeight="700"
          ></Text>
        </Flex>
        <Modal isOpen={modal} onClose={() => onChangeModal(0)} size={"sm"}>
          <ModalOverlay />
          <ModalContent alignSelf={"center"}>
            <ModalHeader bg={brandColor} color="text" borderTopRadius="lg">
              Cancelamento de pedido
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex justify="center" direction={"column"}>
                <Text color={textColor} fontSize="sm" fontWeight="300">
                  Tem certeza que deseja cancelar o pedido <b>{pedido}</b>?
                </Text>
                <Select
                  mt={"20px"}
                  isRequired={true}
                  id="lojas"
                  name="lojasApi"
                  h="44px"
                  fontSize="sm"
                  fontWeight="500"
                  borderRadius="16px"
                  defaultValue={motivoSelect}
                  onChange={(e) => handleChangeSelectCancelamentoMotivo(e)}
                >
                  <option value={0}>Selecione o motivo</option>
                  {motivos.map((option: any) =>
                    motivos ? (
                      <option value={option.id}>{option.descricao}</option>
                    ) : null
                  )}
                </Select>
              </Flex>
            </ModalBody>
            <ModalFooter alignSelf={"center"}>
              <Button
                leftIcon={<MdCheckCircle />}
                bgColor="green.500"
                colorScheme="brand"
                mr={3}
                disabled={motivoSelect != 0 ? false : true}
                onClick={() => cancelarPedido()}
                isLoading={loading}
              >
                Confirmar
              </Button>
              <Button
                colorScheme="brand"
                mr={3}
                onClick={() => onChangeModal(0)}
              >
                Fechar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal
          isOpen={modalView}
          onClose={() => onChangeModalView(0)}
          size={"sm"}
        >
          <ModalOverlay />
          <ModalContent
            alignSelf={"center"}
            maxW={"40%"}
            maxH={"95%"}
            borderRadius="lg"
            overflow="hidden"
          >
            <ModalHeader bg={brandColor} color="text" borderTopRadius="lg">
              Pedido: {pedido}
            </ModalHeader>
            <ModalCloseButton color="white" />
            <ModalBody overflowY={"auto"} bg="gray.50" p={6}>
              <Flex justify="flex-start" direction={"column"}>
                <SimpleGrid columns={{ sm: 1, md: 1 }} spacing={4}>
                  <Text color={textColor} fontSize="lg" fontWeight="500">
                    <b>Status:</b> {statusCor(extrato?.status)}{" "}
                  </Text>
                  {extrato?.status === "CANCELADO" && (
                    <>
                      <Text color={textColor} fontSize="md" fontWeight="400">
                        <b>Data cancelamento:</b> <br />
                      </Text>
                      <Text
                        color={"red.500"}
                        fontSize="md"
                        fontWeight="800"
                        mt="-3"
                      >
                        {maskDataHistorico(extrato?.dataCancelamento)}
                      </Text>
                    </>
                  )}
                  {extrato?.status === "CANCELADO" && (
                    <Text color={textColor} fontSize="md" fontWeight="400">
                      <b>Motivo cancelamento:</b> <br />
                      {statusCancelamento(
                        extrato?.idMotivoCancelamentoPedido
                      )}{" "}
                    </Text>
                  )}

                  {extrato?.tipoPagamento &&
                    idProduto !== 2 &&
                    idProduto !== 6 && (
                      <Text color={textColor} fontSize="md" fontWeight="400">
                        <b>Forma de pagamento:</b>
                        <br />
                        {tipoPagamento(extrato?.tipoPagamento)}
                      </Text>
                    )}
                  {idProduto !== 2 && extrato.idTipo === 3 && (
                    <Text color={textColor} fontSize="md" fontWeight="400">
                      <b>Tipo pedido:</b>
                      <br />
                      {extrato?.tipo}
                    </Text>
                  )}
                  <Text color={textColor} fontSize="md" fontWeight="400">
                    <b>Data do Pedido:</b>
                    <br />
                    {convertDateToFormattedString(extrato?.data)}
                  </Text>
                  {extrato?.dataPagamento && extrato?.dataPagamento !== "0" && (
                    <Text color={textColor} fontSize="md" fontWeight="400">
                      <b>Data do pagamento:</b>
                      <br />
                      {maskDataHistoricoSemHora(extrato?.dataPagamento)}
                    </Text>
                  )}
                  {extrato.idTipo !== 3 && (
                    <Text color={textColor} fontSize="md" fontWeight="400">
                      <b>Valor do pedido:</b> <br />
                      {formatCurrencyFloor(
                        extrato?.valor + extrato?.valorTaxaEntrega || 0
                      )}
                    </Text>
                  )}

                  {extrato?.endereco && (
                    <Text
                      color={textColor}
                      fontSize="md"
                      fontWeight="400"
                      wordBreak="break-word"
                    >
                      <b>Local de entrega do cartão:</b>
                      <br />
                      {extrato?.endereco?.logradouro}{" "}
                      {extrato?.endereco?.numero
                        ? ",  nº " + extrato?.endereco?.numero
                        : null}
                      {extrato?.endereco?.complemento
                        ? " , " + extrato?.endereco?.complemento
                        : null}
                      <br />
                      {extrato?.endereco?.bairro} - {extrato?.endereco?.cidade}
                    </Text>
                  )}
                  {extrato?.valorTaxaEntrega ? (
                    <Text color={textColor} fontSize="md" fontWeight="400">
                      <b>Taxa de entrega:</b>
                      <br />
                      {formatCurrencyFloor(extrato?.valorTaxaEntrega)}
                    </Text>
                  ) : null}
                  <Divider mb={4} mt={4} w={"full"} />
                  {/* <Text color={textColor} fontSize="md" fontWeight="500">
                    <b>Valor Total:</b>
                    <br />
                    {formatCurrencyFloor(
                      extrato?.valor + extrato?.valorTaxaEntrega || 0
                    )}
                  </Text> */}
                  {idProduto != 2 &&
                    idProduto != 6 &&
                    extrato.tipoPagamento !== "GRATUITO" && (
                      <Text color={textColor} fontSize="md" fontWeight="300">
                        <b>Valor pago:</b>
                        <br />
                        {formatCurrencyFloor(extrato?.valorPago || 0)}
                      </Text>
                    )}
                </SimpleGrid>
              </Flex>
            </ModalBody>
            <ModalFooter bg="blue.50" borderBottomRadius="lg">
              <Button
                leftIcon={<MdCancel />}
                colorScheme="red"
                mr={3}
                onClick={() => onChangeModalView(0)}
              >
                Fechar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal
          isOpen={modalViewLinha}
          onClose={() => onChangeModalViewLinha(0)}
          size={"sm"}
        >
          <ModalOverlay />
          <ModalContent alignSelf={"center"}>
            <ModalHeader bg={brandColor} color="text" borderTopRadius="lg">
              Código de barras digitável
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Divider mb="10px" mt="0px" w={"320px"} />
              <Flex
                justify="flex-start"
                h={"80px"}
                w={"323px"}
                direction={"row"}
              >
                <SimpleGrid mt="20px" columns={1} gap="0px" mb="100px">
                  <Text color={textColor} fontSize="md" fontWeight="300">
                    {linhaRecuperavel
                      ? linhaRecuperavel
                      : "Linha digitável não encontrada!"}
                  </Text>
                </SimpleGrid>
              </Flex>
            </ModalBody>
            <ModalFooter alignSelf={"center"}>
              <Button
                leftIcon={<MdCancel />}
                colorScheme="brand"
                mr={3}
                onClick={() => onChangeModalViewLinha(0)}
              >
                Fechar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <PopOverAlertOrange
          handleOpenAlert={handleOpenAlertErro}
          isOpen={isOpenErro}
          title="Ops..."
          subtitle={tipoErroPedido}
          status="error"
        />
      </Flex>
    </>
  );
}
